// extracted by mini-css-extract-plugin
export default {"disable":"menu-item_disable__pzL-Y","active":"menu-item_active__cN-ba"};